import apiFetch from '../../apiFetch'

export default function (dossierHistoricalId, token) {
  return apiFetch({ endPoint: `SaleExportHistorical/${dossierHistoricalId}`, method: 'GET', token: token })
}
